// 获取cookie、
export function getCookie(name) {
  // eslint-disable-next-line one-var
  var arr, reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  // eslint-disable-next-line no-cond-assign
  if (arr = document.cookie.match(reg)) { return (arr[2]) } else { return null }
}

// 设置cookie,增加到vue实例方便全局调用 单位小时
export function setCookie(cName, value, expireTime) {
  var exdate = new Date()
  // exdate.setDate(exdate.getDate() + expiredays)
  exdate.setTime(exdate.getTime() + (expireTime + 8) * 60 * 60 * 1000)
  document.cookie = cName + '=' + escape(value) + ((expireTime == null) ? '' : ';expires=' + exdate.toGMTString())
}

// 删除cookie
export function delCookie(name) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(name)
  if (cval != null) { document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() }
}

// 获取字符数
export function getStringLengthForChinese(val) {
  const str = val ? val.toString(val) : ''
  let result = 0
  for (let i = 0; i < str.length; i++) {
    const temp = str.charCodeAt(i)
    if ((temp > 0x0001 && temp <= 0x007e) || (temp >= 0xff60 && temp <= 0xff9f)) {
      result += 1
    } else {
      result += 2
    }
  }
  return result
}
// 获取字符数(中英倍数计算)
/**
 *
 * @param {*} val 字符串value
 * @param {*} multiple 中英文倍数
 * @returns
 */
export function getStringLengthForMulChinese(val, multiple) {
  const str = val ? val.toString(val) : ''
  let result = 0
  for (let i = 0; i < str.length; i++) {
    const temp = str.charCodeAt(i)
    if ((temp > 0x0001 && temp <= 0x007e) || (temp >= 0xff60 && temp <= 0xff9f)) {
      result += 1
    } else {
      result += multiple
    }
  }
  return result
}

/**
 * 文件下载，根据content-disposition的filename重命名
 * @param {response} 响应体
 */
export const renameDownload = (res) => {
  const filename = getResContentDispositionFilename(res) // 获取filename
  const blob = new Blob([res.data]) // 生成blob对象
  download(filename, blob)
}

/**
 * blob下载
 * @param {string} filename
 * @param {blob} blob
 */
export const download = (filename, blob) => {
  const link = document.createElement('a')

  link.download = filename
  link.href = URL.createObjectURL(blob) // 创建URL对象
  link.click() // 点击下载
  link.remove()
  URL.revokeObjectURL(link.href) // 释放URL对象
}

/**
 * 业务方法，获取content-disposition的filename（filename自带引号）
 */
export const getResContentDispositionFilename = (response) => {
  const disposition = response.headers['content-disposition']
  if (!disposition) return ''
  const filename = decodeURIComponent(disposition.substring(disposition.indexOf('filename') + (disposition.includes('"') ? 10 : 9), disposition.length - 1))
  return filename || ''
}

/**
 * 安全地将字符串转换为布尔值
 * 主要用于处理URL查询参数中的布尔值转换
 * @param {*} value 要转换的值
 * @returns {boolean} 转换后的布尔值
 */
export const parseBoolean = (value) => {
  if (value === null || value === undefined || value === '') {
    return false
  }
  if (typeof value === 'boolean') {
    return value
  }
  if (typeof value === 'string') {
    const lowerValue = value.toLowerCase()
    if (lowerValue === 'true' || lowerValue === '1' || lowerValue === 'yes') {
      return true
    }
    if (lowerValue === 'false' || lowerValue === '0' || lowerValue === 'no') {
      return false
    }
  }
  if (typeof value === 'number') {
    return value !== 0
  }
  // 对于其他类型，使用JavaScript的默认布尔转换
  return Boolean(value)
}

/**
 * 获取路由查询参数中的布尔值
 * @param {Object} query 路由查询对象
 * @param {string} key 参数键名
 * @param {boolean} defaultValue 默认值
 * @returns {boolean} 转换后的布尔值
 */
export const getQueryBoolean = (query, key, defaultValue = false) => {
  if (!query || !key) {
    return defaultValue
  }
  return parseBoolean(query[key])
}



// WEBPACK FOOTER //
// ./src/util/util.js